<router-outlet></router-outlet>
<app-mobile-footer *ngIf="isMobile && url != '/sign-in'"></app-mobile-footer>